import axios from "axios";
import middleware from "../middleware";
import { baseURL } from "../config";
import { validateRequest } from "../../common/validate_request";
import QueryString from "qs";

export const createNewBox = async () => {
  const token = localStorage.getItem("auth-token");
  const response: any = await middleware(
    axios.post(
      `${baseURL}/box/create`,
      { location: { code: "999-9-99" }, is_extra_location: false },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        validateStatus: validateRequest,
      }
    )
  );
  return response;
};
export const getBox = async (data: any) => {
  const token = localStorage.getItem("auth-token");
  const response: any = await middleware(
    axios.get(`${baseURL}/box/find/${data.barcode}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      validateStatus: validateRequest,
    })
  );
  return response;
};
export const getEmptyBoxReplace = async (data: {
  brand: string;
  dateFrom: Date;
  dateTo: Date;
  priority: number;
}) => {
  const token = localStorage.getItem("auth-token");
  const response: any = await middleware(
    axios.get(
      `${baseURL}/box/get_empty_box_replace?${QueryString.stringify(data)}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        validateStatus: validateRequest,
      }
    )
  );
  return response;
};
export const getEmtpyBoxReport = async (brandFilter: string) => {
  const token = localStorage.getItem("auth-token");
  const response: any = await middleware(
    axios.get(
      `${baseURL}/box/get_empty_boxes_report${
        brandFilter && brandFilter != "NONE" ? `?brand=${brandFilter}` : ""
      }`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        validateStatus: validateRequest,
      }
    )
  );
  return response;
};
export const getLocationBrands = async () => {
  const token = localStorage.getItem("auth-token");
  const response: any = await middleware(
    axios.get(`${baseURL}/box/get_location_brands`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      validateStatus: validateRequest,
    })
  );
  return response;
};
export const updateLocationBrands = async () => {
  const token = localStorage.getItem("auth-token");
  const response: any = await middleware(
    axios.get(`${baseURL}/box/update_location_brands`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      validateStatus: validateRequest,
    })
  );
  return response;
};
export const changeLocation = async (data: any) => {
  const token = localStorage.getItem("auth-token");
  const response: any = await middleware(
    axios.post(`${baseURL}/box/change_location`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      validateStatus: validateRequest,
    })
  );
  return response;
};
export const addItem = async (data: any) => {
  const token = localStorage.getItem("auth-token");
  const response: any = await middleware(
    axios.post(`${baseURL}/box/add_item`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      validateStatus: validateRequest,
    })
  );
  return response;
};
export const addBoxPrintQueue = async (boxId: number) => {
  const token = localStorage.getItem("auth-token");
  const response: any = await middleware(
    axios.get(`${baseURL}/box/add_to_print_queue/${boxId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      validateStatus: validateRequest,
    })
  );
  return response;
};
export const deleteItemFromBox = async (boxItem: any) => {
  const token = localStorage.getItem("auth-token");
  const response: any = await middleware(
    axios.post(`${baseURL}/box/delete_item`, boxItem, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      validateStatus: validateRequest,
    })
  );
  return response;
};
export const deleteBox = async (boxId: number) => {
  const token = localStorage.getItem("auth-token");
  const response: any = await middleware(
    axios.delete(`${baseURL}/box/delete_box/${boxId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      validateStatus: validateRequest,
    })
  );
  return response;
};
export const replaceBoxFromEmptyReport = async (data: {
  boxId: number;
  replaceBoxId: number;
  replaceReplacementBoxId: number;
}) => {
  const token = localStorage.getItem("auth-token");
  const response: any = await middleware(
    axios.delete(
      `${baseURL}/box/replace_from_empty_report?${QueryString.stringify(data)}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        validateStatus: validateRequest,
      }
    )
  );
  return response;
};
export const deleteBoxFromEmptyReport = async (boxId: number) => {
  const token = localStorage.getItem("auth-token");
  const response: any = await middleware(
    axios.delete(`${baseURL}/box/delete_from_empty_report/${boxId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      validateStatus: validateRequest,
    })
  );
  return response;
};
